import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, getDocs, doc, updateDoc, query, where, orderBy, startAt, endAt, limit, increment, Timestamp } from 'firebase/firestore'
import { getFunctions, httpsCallable} from 'firebase/functions'
import axios from 'axios'

const geofire = require('geofire-common')

const firebaseConfig = {
    apiKey: "AIzaSyDQ2AnRB_x6tPMOrnHMbKzd3h7r7RMnbhk",
    authDomain: "syringemap.firebaseapp.com",
    projectId: "syringemap",
    storageBucket: "syringemap.appspot.com",
    messagingSenderId: "596708468585",
    appId: "1:596708468585:web:82281d85452725fe2e7ff8",
    measurementId: "G-S2XQ5JBN02"
  };
  
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app)
  const functions = getFunctions(app, 'us-central1')
  const analytics = getAnalytics(app);

  export const writeReview = async (docId, reviewData, rating, finishedAddingReview) => {
      try {

        const data = {
            docData: reviewData,
            docId: docId,
            rating: rating
        }

        const addReview = httpsCallable(functions, 'writeReview');
        addReview(data)
        .then((result) => {
            // Update the data now
            finishedAddingReview()
        })

      } catch (error) {
          console.error(error)
      }
  }

  export const likeQuestionAtLocation = async (docID, increase) => {
      try {
          const docRef = doc(db, 'locationData', docID)
            await updateDoc(docRef, {
                questionCounterUpvote: increment(increase ? 1 : -1)
            })
            .then(() => {
                console.log('Updated likes for doc')
            })
      } catch (error) {
          console.log(error)
      }
  }

  export const dislikeQuestionAtLocation = async (docID, increase) => {
    try {
        const docRef = doc(db, 'locationData', docID)
          await updateDoc(docRef, {
            questionCounterDownvote: increment(increase ? 1 : -1)
          })
          .then(() => {
              console.log('Updated dislikes for doc')
          })
    } catch (error) {
        console.log(error)
    }
}

  export const addCustomLocation = async (locationData, finishedAddingLocation) => {
    try {

      const addCustomLocation = httpsCallable(functions, 'addCustomLocation');
      addCustomLocation(locationData)
      .then((result) => {
          // Update the data now
          finishedAddingLocation()
      })

    } catch (error) {
        console.error(error)
    }
}

  // This function will grab all docs where the geohash is set to null and then update it with a proper geohash based on its lat/long.
  export const updateGeoHashes = async () => {

    try {
        
        // Get all docs where the geohash is still set to "null" (which is set in Unity when I initially upload the docs)
        // This way we don't grab EVERY single doc in the collection.
        // We may also want to limit this operation.
        const q  = query(collection(db, 'locationData'), where("geohash", "==", "null"));
        const querySnapshot = await getDocs(q)
        var counter = 0
        var total = querySnapshot.docs.length
        const data = []

        console.log("There are " + total + " geohashes to update!");

        if(total == 0) {
            console.log("cancelling update");
            return;
        }

        querySnapshot.forEach((doc) => {
            counter++

            //console.log("Doc:");
            console.log(doc.data());

            const lat = parseFloat(doc.data().lat);
            var lng = doc.data().lng;
            if(lng.includes(",")) {
                lng = doc.data().lng.replace(',', '')
            }
            const lngNum = parseFloat(lng);
            try {
                const hash = geofire.geohashForLocation([lat, lngNum])

                updateDoc(doc.ref, {
                    geohash: hash,
                    lng: lng
                })
                .then(() => {
                    console.log('Updated geohash ' + counter + '/' + total)
                })
            } catch (error) {
                console.log(error);
            }
        });
        

    } catch (error) {
        console.error(error)
    }

  }

  export const getGeohashFromLatLng = (latitude, longitude) => {
        const lat = parseFloat(latitude);
        const lng = parseFloat(longitude);
        const hash = geofire.geohashForLocation([lat, lng])
        return hash
  }

  export const getAddressFromCoordinates = async (latitude, longitude, maps, setReverseGeocodingAddress) => {
    const request = {
        location: {
            lat: latitude,
            lng: longitude
        }
    }

    console.log("Getting address 3")
    try {
        const geocoder = new maps.Geocoder()

        geocoder.geocode(request, (response) => {
            console.log(response)
            console.log(response.length)
            console.log(response?.results?.length)
            if(response.length > 0) {
                const address = response[0]
                console.log(address)
                const data = {
                    formatted_address: address.formatted_address,
                    streetNumber: "",
                    street: "",
                    city: "",
                    state: "",
                    zip: ""
                }

                address.address_components.forEach(addressPart => {
                    if(addressPart.types.includes('street_number')) {
                        data.streetNumber = addressPart.long_name;
                    }
                    if(addressPart.types.includes('route')) {
                        data.street = addressPart.long_name;
                    }
                    if(addressPart.types.includes('locality')) {
                        data.city = addressPart.long_name;
                    }
                    if(addressPart.types.includes('administrative_area_level_1')) {
                        data.state = addressPart.short_name;
                    }
                    if(addressPart.types.includes('postal_code')) {
                        data.zip = addressPart.long_name;
                    }
                });

                console.log(data)
                setReverseGeocodingAddress(data)
            }
        })
    } catch (error) {
        console.log(error)
        return { error: error }
    }
  }

  export const getGooglePlaceDataByID = async (map, maps, placeID, setPlaceData) => {

    const request = {
        placeId: placeID,
        fields: ['name', 'formatted_address', 'opening_hours', 'website', 'photos', 'formatted_phone_number'],
    }

    try {
        const service = new maps.places.PlacesService(map)

        service.getDetails(request, (place, status) => {
            setPlaceData(place)
        })
    } catch (error) {
        console.log(error)
    }
  }

  export const getGooglePlacePhoto = async (placeData, setPlacePhotoURL) => {

    try {
        const photoUrl = placeData.photos[0].getUrl({'maxWidth': placeData.photos[0].width, 'maxHeight': placeData.photos[0].height})
        setPlacePhotoURL(photoUrl)
    } catch (error) {
        setPlacePhotoURL('')
    }
  }


export const getPlacesData = async (centerCoords, zoomLevel, setPlaces, setIsLoading, category) => {

    try {

        // Conversion solution from:
        // https://stackoverflow.com/questions/41481723/convert-google-map-zoom-level-into-km
        const radiusInKM = ((40000 / Math.pow(2, zoomLevel)) * 2)
        const radiusInM = radiusInKM * 1000
        
        // Geohashing query solution from:
        // https://firebase.google.com/docs/firestore/solutions/geoqueries

        // Each item in 'bounds' represents a startAt/endAt pair. We have to issue
        // a separate query for each pair. There can be up to 9 pairs of bounds
        // depending on overlap, but in most cases there are 4.
        const center = [centerCoords.lat, centerCoords.lng]
        const bounds = geofire.geohashQueryBounds(center, radiusInM);
        const promises = [];
        const data = [];
        for (const b of bounds) {
            const q = query(collection(db, 'locationData'), orderBy('geohash'), startAt(b[0]), endAt(b[1]), limit(1000))

            promises.push(getDocs(q));
        }

        setIsLoading(true)

        // Collect all the query results together into a single list
        Promise.all(promises).then((snapshots) => {
            for (const snap of snapshots) {
                for (const doc of snap.docs) {
                    const lat = parseFloat(doc.get('lat'));
                    const lng = parseFloat(doc.get('lng'));

                    // We have to filter out a few false positives due to GeoHash
                    // accuracy, but most will match
                    const distanceInKm = geofire.distanceBetween([lat, lng], center);
                    const distanceInM = distanceInKm * 1000;
                    if (distanceInM <= radiusInM) {
                        const docData = doc.data()

                        // Set doc id as part of the data that I'll read later
                        docData.docId = doc.id

                        data.push(docData)
                    }
                }
            }

        }).then(() => {
            // Process the matching documents
            
            setPlaces(data)
            setIsLoading(false)
        });

    } catch (error) {
        console.log(error)
    }
}